var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_2112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 14H1.00001C0.447699 14 0 13.5523 0 13C0 12.4477 0.447699 12 1.00001 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.00001H1.00001C0.447699 9.00001 0 8.55231 0 8.00004C0 7.44776 0.447699 7.00003 1.00001 7.00003H15C15.5523 7.00003 16 7.44773 16 8.00004C16 8.55235 15.5523 9.00001 15 9.00001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.00001H1.00001C0.447699 4.00001 0 3.55231 0 3.00001C0 2.4477 0.447699 2 1.00001 2H15C15.5523 2 16 2.4477 16 3.00001C16 3.55231 15.5523 4.00001 15 4.00001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_2112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumburger);
export default __webpack_public_path__ + "static/media/humburger.4e5e2d2b67960483c41fae529befa7a4.svg";
export { ForwardRef as ReactComponent };